// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width: 1023px){.bw-monthWrapper{padding-bottom:1.6rem}}.bw-calendarMonth{display:grid;grid-template-columns:repeat(7, 1fr);grid-template-rows:1.5rem repeat(6, auto);padding-top:0;padding-bottom:0;text-align:center}.bw-calendarMonth>*{align-self:center}@media only screen and (max-width: 1023px){.bw-title{justify-content:space-between}}@media only screen and (min-width: 1024px){.bw-title{justify-content:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monthWrapper": "bw-monthWrapper",
	"calendarMonth": "bw-calendarMonth",
	"title": "bw-title"
};
module.exports = ___CSS_LOADER_EXPORT___;
